import { menuAnatomy as parts } from "@chakra-ui/anatomy";
export { Menu, MenuButton, MenuList, MenuItem, MenuItemOption, MenuGroup, MenuOptionGroup, MenuDivider } from "@chakra-ui/react";
const baseStyleList = {
    bg: '#fff',
    boxShadow: 'rgba(25, 25, 34, 0.24) 0px 4px 20px 0px',
    color: 'inherit',
    minW: '3xs',
    py: '2',
    zIndex: 1,
    borderRadius: 'md',
    borderWidth: '1px',
    border: 'none',
    _dark: {
        bg: 'gray.700',
        boxShadow: 'dark-lg'
    }
};
const baseStyleItem = {
    py: '0.4rem',
    px: '0.8rem',
    transitionProperty: 'background',
    transitionDuration: 'ultra-fast',
    transitionTimingFunction: 'ease-in',
    _focus: {
        bg: 'gray.100'
    },
    _active: {
        bg: 'gray.200'
    },
    _expanded: {
        bg: 'gray.100'
    },
    _dark: {
        _focus: {
            bg: 'whiteAlpha.100'
        },
        _active: {
            bg: 'whiteAlpha.200'
        },
        _expanded: {
            bg: 'whiteAlpha.100'
        }
    },
    _disabled: {
        opacity: 0.4,
        cursor: 'not-allowed'
    }
};
const baseStyleGroupTitle = {
    mx: 4,
    my: 2,
    fontWeight: 'semibold',
    fontSize: 'sm'
};
const baseStyleCommand = {
    opacity: 0.6
};
const baseStyleDivider = {
    border: 0,
    borderBottom: '1px solid',
    borderColor: 'inherit',
    my: '0.5rem',
    opacity: 0.6
};
const baseStyleButton = {
    transitionProperty: 'common',
    transitionDuration: 'normal'
};
const baseStyle = {
    button: baseStyleButton,
    list: baseStyleList,
    item: baseStyleItem,
    groupTitle: baseStyleGroupTitle,
    command: baseStyleCommand,
    divider: baseStyleDivider
};
export const ThemedMenu = {
    parts: parts.keys,
    baseStyle
};

//# sourceMappingURL=Menu.js.map